// extracted by mini-css-extract-plugin
export default {"jiraStatusTag":"Bw3KTXjPatXveV61KLAm"};